export const LOAD_STORAGE = 'LOAD_STORAGE';


// WEBPACK FOOTER //
// ./js/actions/Storage.js